import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import CookieHelper from "@Scripts/Common/CookieHelper";

@Component({ name: "Dialog" })
export default class Dialog extends Vue {
    public isVisible: boolean = false;
    public dialog: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const self = this;

        await this.getData();

        if (this.dialog) {
            let dialogIdMaster = CookieHelper.getCookie("DialogInfo");
            if (dialogIdMaster !== this.dialog.idMaster) {
                setTimeout(function () {
                    self.isVisible = true;
                }, 5000);
            }
        }
    }

    public async getData() {
        this.dialog = (await Axios.post(this.routes.Dialog_GetData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public close() {
        CookieHelper.setCookie("DialogInfo", this.dialog.idMaster, 183);
        this.isVisible = false;
    }
};